module.exports = __webpack_public_path__ + "static/media/inverter.0ee181a3.svg";